import React, { useEffect, useRef, useState} from "react";

export default function AdminFooter(){
	let copyrightDate = new Date();
	const thisYear = copyrightDate.getFullYear();
    return(<>
        <div className="footerSection">
				<div className="continer-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="CopyrightText">
								<p>Copyright © {thisYear}. All rights reserved.</p>
							</div>							
						</div>
					</div>
				</div>
			</div>
    </>)
}
